import React from 'react';
import { Grid, Box, Typography, Container } from '@mui/material';
import { useStyles } from './styles';
import LazyLoad from 'react-lazyload';
import Image from 'next/image';

export default function InfodesignKorean() {
  const classes = useStyles();

  return (
    <Box px={6} py={8} bgcolor="#FAFAFA">
      <Container>
        <LazyLoad offset={100}>
          <Grid item xs={12}>
            <Typography variant="h4" component="h2" align="center" className={classes.title}>
              연구를 시각적으로 몇 분 만에 완성!
            </Typography>

            <Box textAlign="center">
              <Typography variant="body1" className={classes.infoText}>
                Mind the Graph는 사용이 용이하며 초보자부터 전문가, 개인 또는 그룹, 소규모 연구실 및
                <br />
                기관에 이르기까지 누구나 쉽게 연구 일러스트를 제작할 수 있습니다.
              </Typography>
            </Box>
          </Grid>

          <Grid className={classes.itemContainer} container={true} spacing={8} alignItems="center">
            <Grid item={true} xs={12} sm={6} lg={4}>
              <Box className={classes.item}>
                <Image
                  src="/images/drag-drop-icon.webp"
                  loading="lazy"
                  height={75}
                  width={69.16}
                  alt="Drag and Drop"
                />
                <Typography component="h2">드래그 앤 드롭</Typography>
                <Typography className={classes.subTextContent}>
                  일러스트, 텍스트, 템플릿을 선<br />택 후 사용하세요
                </Typography>
              </Box>
            </Grid>

            <Grid item={true} xs={12} sm={6} lg={4}>
              <Box className={classes.item}>
                <Image
                  src="/images/premade-icon.webp"
                  loading="lazy"
                  height={75}
                  width={76.66}
                  alt="Pre-made resources"
                />
                <Typography component="h2">풍부한 자료</Typography>
                <Typography className={classes.subTextContent}>
                  시간을 낭비하지 마세요! 선택 후 색<br /> 상, 텍스트 등을 맞춤 제작하세요.
                </Typography>
              </Box>
            </Grid>

            <Grid item={true} xs={12} sm={6} lg={4}>
              <Box className={classes.item}>
                <Image
                  src="/images/slides-icon.webp"
                  loading="lazy"
                  height={75}
                  width={75}
                  alt="Slides presentation"
                />
                <Typography component="h2">슬라이드 프리젠테이션</Typography>
                <Typography className={classes.subTextContent}>
                  학술 일러스트로 강력한 연구
                  <br /> 프리젠테이션을 만들어보세요.
                </Typography>
              </Box>
            </Grid>

            <Grid item={true} xs={12} sm={6} lg={4}>
              <Box className={classes.item}>
                <Image
                  src="/images/multiple-sizing-options-icon.webp"
                  loading="lazy"
                  height={75}
                  width={73.27}
                  alt="Pre-set sizes"
                />
                <Typography component="h2">다양한 크기 옵션</Typography>
                <Typography className={classes.subTextContent}>
                  아카데믹 용도에 맞는 다양한 크기의 템플릿
                </Typography>
              </Box>
            </Grid>

            <Grid item={true} xs={12} sm={6} lg={4}>
              <Box className={classes.item}>
                <Image
                  src="/images/ondemand-icon.webp"
                  loading="lazy"
                  height={75}
                  width={61.42}
                  alt="On-demand illustrations"
                />
                <Typography component="h2">맞춤 일러스트</Typography>
                <Typography className={classes.subTextContent}>
                  원하는 것을 찾지 못하셨나요?
                  <br /> 요구사항에 맞는 디자인 제작도
                  <br /> 지원해 드립니다
                </Typography>
              </Box>
            </Grid>

            <Grid item={true} xs={12} sm={6} lg={4}>
              <Box className={classes.item}>
                <Image
                  src="/images/online-platform-icon.webp"
                  loading="lazy"
                  height={75}
                  width={76.75}
                  alt="Online plataform"
                />
                <Typography component="h2">온라인 플랫폼</Typography>
                <Typography className={classes.subTextContent}>
                  필요할 경우 언제 어디서든
                  <br /> 접속하세요.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </LazyLoad>
      </Container>
    </Box>
  );
}
